// extracted by mini-css-extract-plugin
module.exports =  {"breadcrumbs":"_32bbee5fda--breadcrumbs--KqVG7","breadcrumbs-link":"_32bbee5fda--breadcrumbs-link--JAzZV","breadcrumbs-delimiter":"_32bbee5fda--breadcrumbs-delimiter--CcXCV"};